export default "__VITE_ASSET__EoVF0VGv__"